import { mdiSync, mdiFileExport } from "@mdi/js";
import _DatabaseModel, { i18n } from "./_DatabaseModel";

const KPIS_TAB_DATA = 94;
const KPIS_TAB_DEFINITION = 95;
const KPIS_TAB_PREVIEW = 96;

class Kpi extends _DatabaseModel {
  static model = "kpi";
  static editDialogComponent = "kpi-create-wizard";

  static createNewObject = {
    object: {
      definition: { calculation: {}, visualization: {} },
    },
  };

  static tableHeaders = [
    { textKey: "form.label.name", value: "name" },
    {
      textKey: "kpi.label.calculation",
      value: "calculation",
      translationPrefix: "kpi.calculations",
    },
    {
      textKey: "kpi.label.visualization",
      value: "visualization",
      translationPrefix: "kpi.visualizations",
    },
  ];

  static show = {
    buttons: ["edit"],
    reloadingModels: [],
  };

  static filter = {
    parts: {
      fields: ["name", "calculation", "visualization"],
      extended_fields: ["description", "time_filter"],
      time_filter: ["created_at", "updated_at"],
    },
  };

  static operations = ["export"];

  static refresh_rates = [0, 60, 360, 1440];

  static calculations = [
    "ratio",
    "average",
    "issue_count",
    "sla_count",
    "risk_count",
    "sla_overview",
    "time_series",
    "detail_sum",
    "map",
    "map_colored",
    "transaction_item_sum",
  ];

  static visualizations = [
    "map",
    "pie_chart",
    "donut_chart",
    "column_chart",
    "bar_chart",
    "line_chart",
    "area_chart",
    "time_line",
    "stacked_column_chart",
    "stacked_bar_chart",
    "table",
  ];

  static cardFields(object) {
    return {
      title: object.name,
      subtitle: i18n.t(`kpi.visualizations.${object.visualization}`),
      tags: true,
    };
  }

  static basicInfo(object) {
    return [
      {
        labelKey: "team.team",
        value: object.team,
        type: "link",
        to: "teams",
      },
      {
        labelKey: "kpi.label.refresh_rate",
        value: i18n.t(`kpi.refresh_rates.${object.refresh_rate}`),
        type: "plain",
      },
      {
        labelKey: "kpi.label.calculation",
        value: i18n.t(`kpi.calculations.${object.calculation}`),
        type: "plain",
      },
      {
        labelKey: "kpi.label.visualization",
        value: i18n.t(`kpi.visualizations.${object.visualization}`),
        type: "plain",
      },
      {
        labelKey: "kpi.label.computed_at",
        value: object.computed_at,
        type: "date_time",
      },
      {
        labelKey: "form.label.created_at",
        value: object.created_at,
        type: "date_time",
      },
    ];
  }

  static submenuActions = [
    this.commonActions.duplicate,
    {
      action: "reloadNow",
      icon: mdiSync,
      titleKey: "kpi.label.submenu.compute_now",
    },
    {
      action: "exportXLSX",
      icon: mdiFileExport,
      titleKey: "action.export",
      display: (object) => object.visualization !== "map",
    },
    this.commonActions.openActivities,
    this.commonActions.delete,
  ];

  static tabs = [
    this.detailTab,
    {
      titleKey: "kpi.label.preview",
      permission: KPIS_TAB_PREVIEW,
      component: "PreviewKpiTab",
      disabled: this.defaultDisabledTab(),
    },
    {
      titleKey: "kpi.label.definition",
      permission: KPIS_TAB_DEFINITION,
      component: "JsonDefinitionTab",
      disabled: this.defaultDisabledTab(),
    },
    {
      titleKey: "kpi.label.data",
      permission: KPIS_TAB_DATA,
      component: "KpiDataTab",
      disabled: () => false,
    },
  ];

  static exportXLSX(kpi) {
    import("xlsx").then((xlsx) => {
      const wb = xlsx.utils.book_new();
      const sheet = xlsx.utils.aoa_to_sheet(kpi.data);
      let sheetName = kpi.name;
      if (sheetName.length > 31) {
        sheetName = sheetName.slice(0, 28) + "...";
      }
      xlsx.utils.book_append_sheet(wb, sheet, sheetName);
      xlsx.writeFile(wb, "kpi_export.xlsx");
    });
  }
}

export default Kpi;
